module.exports = Handlebars;


//////////////////
// WEBPACK FOOTER
// external "Handlebars"
// module id = 1137
// module chunks = 75